import { useEffect, useState } from "react";
import {
  isBenefitAvailableForTier,
  getCustomerTierId,
} from "../../utilities/loyaltyUtils";
import LoyaltyProgressIndicator from "../../components/progress-indicator";
import { isAuthenticated, promptLogin } from "../../utilities/identityUtils";
import AsosWorldLogo from "../../assets/asos-world-logo.svg";
import Tier3Icon from "../../assets/loyalty-tier-3.svg";
import Tier4Icon from "../../assets/loyalty-tier-4-outlined.svg";

import styles from "./styles";
import Decoration from "../../components/decoration";
import { PropTypes } from "prop-types";
import { getFloor } from "../../utilities/webContextUtils";
import classNames from "classnames";
import { trackPageEvent } from "../../utilities/trackPageEvent";
import DownloadApp from "../../components/download-app";

const MembersDay = ({ appConfig }) => {
  const { isPreSale } = appConfig;
  const [showMembersDay, setShowMembersDay] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [floor, setFloor] = useState("women");
  const [tierId, setTierId] = useState();

  useEffect(() => {
    const determineTargetedCustomer = async () => {
      const authenticated = await isAuthenticated();
      if (!authenticated) {
        await promptLogin();
      }

      try {
        const currentTierId = await getCustomerTierId();
        if (currentTierId) {
          setTierId(currentTierId);
          const availableBenefit = await isBenefitAvailableForTier(
            currentTierId,
            "MembersOnlySale"
          );
          if (availableBenefit) {
            setShowMembersDay(true);
          }
        }
        setFloor(getFloor());
        setLoaded(true);
      } catch (e) {
        setShowMembersDay(false);
        setLoaded(true);
      }
    };
    determineTargetedCustomer();
  }, [loaded]);

  const getCuratedBy = () => (floor === "women" ? "Bella" : "Romeo");

  useEffect(() => {
    if (loaded && showMembersDay && tierId) {
      const analyticsPayload = {
        pageName: `members day ${
          isPreSale ? "plan your buy" : "live event"
        } landing page`,
        consentStatus: "OptedIn",
        currentTier: tierId,
      };
      trackPageEvent(analyticsPayload, { eVar229: "members day" });
    }
  }, [loaded, showMembersDay, tierId, isPreSale]);

  return (
    <>
      {loaded ? (
        showMembersDay ? (
          <div
            className={classNames(styles.container, {
              [styles.menswear]: floor === "men",
            })}
          >
            <div className={styles.hero}>
              <span className={styles.appExclusive}>App Exclusive</span>
              <div className={styles.tierBadges}>
                <span>
                  <Tier3Icon alt="Tier 3" className={styles.tierIcon} /> Icon
                </span>
                <span>
                  <Tier4Icon alt="Tier 3" className={styles.tierIcon} />{" "}
                  A-lister
                </span>
                <Decoration
                  height="8"
                  width="60"
                  className={styles.decoration}
                  fill="black"
                />
              </div>
              <div className={styles.content}>
                <div className={styles.alignedLeft}>
                  <AsosWorldLogo
                    aria-label="ASOS World logo"
                    role="img"
                    className={styles.asosWorldLogo}
                  />
                  <h1>What is members day?</h1>
                  <Decoration
                    height="24"
                    width="120"
                    className={styles.decoration}
                    fill="black"
                  />
                  <p>
                    {`We're celebrating our most-valued customers by giving you exclusive prices on our best styles for one day only.`}
                  </p>
                  <Decoration
                    height="14"
                    width="180"
                    className={styles.decoration}
                    fill="black"
                  />
                </div>
                <div className={styles.alignedRight}>
                  <Decoration
                    height="8"
                    width="136"
                    className={styles.decoration}
                    fill="black"
                  />
                  <span>
                    <h1>App-only deals</h1>
                  </span>
                  <p>Shop exclusive Members Day prices only on the app.</p>
                  <div className={styles.downloadButton}>
                    <DownloadApp isPreSale={isPreSale} />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.edits}>
              <div className={styles.firstEdit}>
                <div className={styles.alignedLeft}>
                  <Decoration
                    height="8"
                    width="136"
                    className={styles.decoration}
                    fill="black"
                  />
                  <h1>
                    {isPreSale
                      ? "Your sneak peek starts now"
                      : "Members Day starts now"}
                  </h1>
                  <p>
                    {isPreSale
                      ? "Up-to-50%-off prices unlock at 8:00 tomorrow morning, but you're first in line so download the app and prep your basket now."
                      : "Up-to-50%-off prices and you're first in line so download the app now."}
                  </p>

                  <div className={styles.downloadButton}>
                    <DownloadApp isPreSale={isPreSale} />
                  </div>
                </div>
              </div>
              <div className={styles.secondEdit}>
                <div className={styles.alignedRight}>
                  <Decoration
                    height="16"
                    width="136"
                    className={styles.decoration}
                    fill="black"
                  />
                  <h1>{`Curated by ASOS ${getCuratedBy()}`}</h1>
                  <p>
                    {`Shop ASOS ${getCuratedBy()}'s handpicked edit at exclusive members-only prices.`}
                  </p>
                  <Decoration
                    height="8"
                    width="136"
                    className={styles.decoration}
                    fill="black"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>{(window.location.href = "/")}</>
        )
      ) : (
        <LoyaltyProgressIndicator />
      )}
    </>
  );
};

export default MembersDay;

MembersDay.propTypes = {
  appConfig: PropTypes.object,
};
